
const IS_PROD = (window.location.hostname === 'www.sublocade.com' || window.location.hostname.indexOf('-preprod') > -1);
const IS_PREVIEW = window.location.hostname.indexOf('fullstack-preview') > -1;
const API_ENDPOINT = (IS_PROD || window.location.hostname.indexOf('.klickcloud.net') > 0) && !IS_PREVIEW ? '/api' : 'https://sublocade-uat.klickcloud.net/api';
const CRM_API_ENDPOINT = (IS_PROD) ? 'https://tsuesda3ng.execute-api.us-west-2.amazonaws.com/release/api' : 'https://vt3ryduizh.execute-api.us-west-2.amazonaws.com/stage/api';

module.exports = {
  IS_PROD,
  API_ENDPOINT,
  CRM_API_ENDPOINT,
};
